import React from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui, MuiLab, TextField } from 'components';

const DEFAULT_ORDER_TYPE_OPTIONS = [
  { label: 'Pedido único', icon: 'inventory', value: 'order' },
  { label: 'Contrato', icon: 'assignment', value: 'contract' },
  { label: 'Mensalidade', icon: 'event', value: 'tuition' },
];

export const RECURRENCE_ORDER_TYPE_OPTIONS = [
  { label: 'Pedido único', icon: 'inventory', value: 'order' },
  { label: 'Recorrência', icon: 'autorenew', value: 'recurrence' },
];

function OrderTypeFilter(props) {
  const {
    multiple,
    selectedType,
    onSelect,
    options = DEFAULT_ORDER_TYPE_OPTIONS,
    ...otherProps
  } = props;

  const handleTypeFilter = (event, selectedOption) =>
    onSelect(
      !multiple ? selectedOption?.value : selectedOption?.map(option => option.value).join(','),
    );

  return (
    <MuiLab.Autocomplete
      multiple={multiple}
      options={options}
      limitTags={3}
      value={
        !multiple
          ? options.find(option => option?.value === selectedType) || null
          : options.filter(option => selectedType?.split(',').includes(option?.value))
      }
      getOptionLabel={option => option?.label || ''}
      getOptionSelected={(option, value) => option?.value === value?.value}
      onChange={handleTypeFilter}
      renderOption={(option, { selected }) => (
        <>
          <Mui.ListItemIcon>
            <Mui.Icon color={selected ? 'primary' : 'action'}>{option?.icon}</Mui.Icon>
          </Mui.ListItemIcon>
          <Mui.ListItemText
            primaryTypographyProps={{ color: selected ? 'primary' : 'textSecondary' }}>
            {option?.label}
          </Mui.ListItemText>
        </>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Mui.Chip
            avatar={
              <Mui.Avatar>
                <Mui.Icon fontSize="small">{option?.icon}</Mui.Icon>
              </Mui.Avatar>
            }
            label={option?.label}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={inputParams => (
        <TextField {...inputParams} label="Tipo do pedido" margin="none" />
      )}
      {...otherProps}
    />
  );
}

OrderTypeFilter.propTypes = {
  multiple: PropTypes.bool,
  selectedType: PropTypes.string,
  onSelect: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
      value: PropTypes.string.isRequired,
    }),
  ),
};

export default OrderTypeFilter;
